"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _browserCookies = _interopRequireDefault(require("browser-cookies"));

var _isClient = _interopRequireDefault(require("../isClient/isClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var setCookie = function setCookie(name, value, expireAfterDays, res) {
  if (res && res.cookie) {
    res.cookie(name, value, {
      expires: expireAfterDays
    });
  } else {
    var client = (0, _isClient["default"])();
    var secure = false;

    if (client && document && document.location) {
      secure = document.location.protocol.toLowerCase().includes('s');
    }

    if (client) {
      _browserCookies["default"].set(name, value, {
        expires: expireAfterDays,
        secure: secure
      });
    }
  }
};

var _default = setCookie;
exports["default"] = _default;
//# sourceMappingURL=setCookie.js.map